<template>
  <router-view />
</template>

<style lang="scss">
@import "style.scss";
</style>
